
// desktop.module.js

"use strict";

import angular from "angular";
import { desktopRouting } from "./desktop.module.routing";


import { LoggerController } from "./../../core/logger";

class DesktopController  extends LoggerController {
  static get $inject() { return  ['$state', '$transitions', '$scope', 'bxMenu', '$location', '$log']}
  constructor ($state, $transitions, $scope, bxMenu, $location, $log) {
      super($log);
      this.$state = $state;
      this.$transitions = $transitions;
      this.$scope = $scope;
      this.$scope.menu = [];
      this.bxMenu = bxMenu;
      this.location = $location;
  }


  
  loadMenu(menu){
   

      

      this.$scope.menu =  menu;

      for (const key in menu) {
          if (menu.hasOwnProperty(key)) {
              const element = menu[key];

              if(element.skeep){
                  continue;
              }


          }
      }
      
      

  }


  $onInit() {
      
      var self = this;
      this.bxMenu.getMenu().then(function(data){ 
          
          self.$scope.menu =data;
          self.checkState();
          setTimeout(function(){self.$scope.$apply() },0);
      })
     // BX.addCustomEvent('onDesktopMenuLoaded', BX.delegate( this.loadMenu,this));
  }

  checkState(){
   
  }

}



class DesktopComponent {
    constructor() {
        this.template=require("./../../../../partials/desktop.html");
        this.controller = DesktopController;
    }
}


const DESKTOP_MODULE = angular
  .module("moetp.desktop", [])
  .component("desktop", new DesktopComponent())

  
  .config(desktopRouting);

export { DESKTOP_MODULE };




// WEBPACK FOOTER //
// ./src/components/desktop/desktop.module.js